export enum AddTruckFomNames {
	truckReg = 'truckReg',
	truckType = 'truckType',
	truckCapacity = 'truckCapacity',
}
